module.exports = __webpack_public_path__ + "static/img/driver-login-bg.8817bb7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/driver-login-bg.png
// module id = nxIm
// module chunks = 1